<template>
  <v-dialog v-model="dialog" :content-class="layout == 'portal'
    ? 'login-dialog fixit-background-gradient'
    : 'login-dialog chain-background-white'
    " class="dialog-width" max-width="768" :fullscreen="isMounted && $vuetify.breakpoint.smAndDown" persistent
    no-click-animation @click:outside="
      [state.START, state.TERMS].includes(currentForm) && !isProfile && allowClickOutside
        ? closeDialog()
        : () => { }
      ">
    <transition v-if="showRedirectScreen" mode="out-in" :name="[state.START].includes(currentForm)
      ? 'scroll-x-reverse-transition'
      : 'scroll-x-transition'
      ">
      <the-redirect-loader :returnUrl="returnUrl" :layout="layout" />
    </transition>
    <transition v-else mode="out-in" :name="[state.START].includes(currentForm)
      ? 'scroll-x-reverse-transition'
      : 'scroll-x-transition'
      ">
      <the-selection key="select_screen" v-if="[state.START].includes(currentForm)" :isMounted="isMounted"
        @changeView="changeView" @close="closeDialog" :oauthUrl="oauthUrl" :layout="layout" :isProfile="isProfile"
        :use-fixit-oauth-login="useFixitOauthLogin" @notify="sendNotification"
        @setUser="(user) => (this.currentUser = user)" :api-url="apiUrl"></the-selection>
      <the-terms key="terms_of_use" v-else-if="[state.TERMS].includes(currentForm)" :isMounted="isMounted"
        :layout="layout" @changeView="changeView" :previousForm="previousForm"></the-terms>
      <fixit-login key="login" ref="loginFlow" v-else-if="[state.LOGIN].includes(currentForm)" :isMounted="isMounted"
        @changeView="changeView" :isTpn="isTpn" :tpnChainId="tpnChainId" :tpnSiteId="tpnSiteId" :useAxios="useAxios"
        :api-url="apiUrl" :layout="layout" :isProfile="isProfile" @close="closeDialog"
        @setUser="(user) => (this.currentUser = user)" @setUpdateData="setUpdateData"
        @setPassword="setPassword" :prefilledMobile="prefilledMobile"></fixit-login>
      <create-profile key="registration" v-else-if="[state.REGISTRATION].includes(currentForm)" :useAxios="useAxios"
        :salons="salons" :apiUrl="apiUrl" :isTpn="isTpn" :tpnChainId="tpnChainId" :tpnSiteId="tpnSiteId" :user="user"
        :oauthData="oauthData" :oauthUrl="oauthUrl" :layout="layout" :isProfile="isProfile" @close="closeDialog"
        @setUser="(user) => (this.currentUser = user)" @changeView="changeView" :initialCreateStep="initialCreateStep">
      </create-profile>
      <oauth key="oauth-flow" v-else-if="[state.OAUTH].includes(currentForm)" :useAxios="useAxios" :salons="salons"
        :apiUrl="apiUrl" :isTpn="isTpn" :tpnChainId="tpnChainId" :tpnSiteId="tpnSiteId" :user="user"
        :oauthData="oauthData" :oauthUrl="oauthUrl" :layout="layout" :isProfile="isProfile" @close="closeDialog"
        @setUser="(user) => (this.currentUser = user)" @changeView="changeView" @loginWithNumber="(params) => loginWithNumber(params)" :initialCreateStep="initialCreateStep">
      </oauth>
      <the-email-verification :vippsEmail="vippsEmail" :username="username" :email="email"
        :client-identity="clientIdentity" key="verify-email" v-else-if="[state.EMAILCODE].includes(currentForm)"
        :isMounted="isMounted" @changeView="changeView" :isTpn="isTpn" :tpnChainId="tpnChainId" :tpnSiteId="tpnSiteId"
        :useAxios="useAxios" :api-url="apiUrl" @close="closeDialog" @setUser="loggedInUser"
        :layout="layout"></the-email-verification>
      <the-sms-verification :oauthSourceEnum="oauthSourceEnum" :oauthUserId="oauthUserId" :username="username"
        :email="email" :client-identity="clientIdentity" key="verify-sms"
        v-else-if="[state.SMSCODE].includes(currentForm)" :isMounted="isMounted" @changeView="changeView" :isTpn="isTpn"
        :tpnChainId="tpnChainId" :tpnSiteId="tpnSiteId" :useAxios="useAxios" :api-url="apiUrl" @close="closeDialog"
        @setUser="loggedInUser" :layout="layout"></the-sms-verification>
      <the-missing-profile-info v-if="[state.UPDATE_USER].includes(currentForm)" title="Oppdater profil"
        description="Vi mangler litt informasjon om deg. Vennligst oppgi følgende:" :tempUser="tempUser"
        :layout="layout" @submit="verifyMissingInfo"></the-missing-profile-info>
    </transition>
    <common-dialog :hide-actions="true" v-if="paymentError" :show="paymentError" icon="fxt-warning"
      @closeDialog="closeError()" :layout="layout">
      <p>
        Denne digitale profilen er allerede koblet med en annen kundeprofil, du
        kan derfor ikke benytte digital betaling.
      </p>
    </common-dialog>
  </v-dialog>
</template>

<script>
import {
  TheSelection,
  TheTerms,
  CreateProfile,
  FixitLogin,
  TheRedirectLoader,
  Oauth
} from "./components";
import { CommonDialog } from "../../components/Common/CommonComponents";

import { User } from "../../models";
import TheEmailVerification from "./components/TheEmailVerification.vue";
import TheSMSVerification from "./components/TheEmailVerification.vue";
import TheMissingProfileInfo from './components/TheMissingProfileInfo.vue'
import AppSvc from "../../services/app-svc";

let service = null;

export default {
  name: "login-dialog",
  components: {
    TheSelection,
    TheTerms,
    CreateProfile,
    FixitLogin,
    TheEmailVerification,
    TheSMSVerification,
    CommonDialog,
    TheRedirectLoader,
    TheMissingProfileInfo,
    Oauth
  },
  props: {
    apiUrl: {
      type: String,
      required: true,
    },
    allowClickOutside: {
      type: Boolean,
      requred: false,
      default: true
    },
    oauthUrl: {
      type: String,
      required: true,
    },
    user: {
      type: Object,
      required: false,
    },
    layout: {
      type: String,
      required: false,
      default: "chain",
    },
    overrideOptions: {
      type: Object,
    },
    isProfile: {
      type: Boolean,
      required: false,
      default: false,
    },
    useFixitOauthLogin: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: Boolean,
    useAxios: Boolean,
    salons: Array,
  },
  data() {
    return {
      isMounted: false,
      previousForm: "select_screen",
      vippsEmail: "",
      state: {
        LOGIN: "login",
        REGISTRATION: "registration",
        EMAILCODE: "verify-email",
        SMSCODE: "verify-sms",
        START: "select_screen",
        TERMS: "terms_of_use",
        WELCOME: "welcome-screen",
        UPDATE_USER: "update-userdata",
        OAUTH: "oauth-flow"
      },
      registerForm: {
        firstName: "",
        lastName: "",
        address: "",
        postalCode: "",
        postalArea: "",
        birthDate: "",
        mobile: "",
      },
      form: {
        mobile: null,
        password: null,
        rememberMe: false,
      },
      verificationForm: {
        mobile: null,
        verificationCode: null,
      },
      currentForm: "select_screen",
      loginDescription: "",
      clientIdentity: null,
      formValidity: false,
      loading: false,
      icon: require("../../assets/img/app-icon.png"),
      vippsIcon: require("../../assets/img/Vipps-Logo.png"),
      googleIcon: require("../../assets/img/google-logo-login.svg"),
      verificationFormMobileValidity: false,
      verificationFormVerificationCodeValidity: false,
      registrationUser: new User(),
      redirectUrl: null,
      email: null,
      code: null,
      returnUrl: null,
      paymentError: false,
      showRedirectScreen: false,
      tempUser: null,
      isVippsLogin: false,
      isGoogleLogin: false,
      oauthSourceEnum: '',
      oauthUserId: '',
      initialCreateStep: '',
      oauthData: null,
      prefilledMobile: ''
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit("close-click", value);
        // if (!value) this.reset();
      },
    },
    currentUser: {
      get() {
        return this.user;
      },
      set(user) {
        if (user.onlineSluttKundeId && this.returnUrl) {
          this.showRedirectScreen = true;
          if (localStorage.getItem('returnUrl')) {
            localStorage.removeItem('returnUrl')
          }
          window.open(this.returnUrl, "_self");
        } else {
          this.$emit("setUser", user);
        }
      },
    },
    isVerificationCodeSent() {
      return !!this.clientIdentity;
    },
    isTpn() {
      return (
        this.$route?.path.includes("/booking") ||
        this.$route?.path.includes("/nettbutikk") ||
        this.salons?.length > 0
      );
    },
    tpnChainId() {
      return this.isTpn
        ? this.$route?.path.includes("/nettbutikk")
          ? this.salons[0]?.chainId
          : this.salons?.length > 1
            ? this.salons[0]?.chainId
            : 0
        : 0;
    },
    tpnSiteId() {
      return this.isTpn && this.salons?.length == 1
        ? this.salons[0]?.siteId
        : 0;
    },
  },
  methods: {
    sendNotification(snackbar) {
      this.$emit('notify', snackbar);
    },
    setPassword(pass) {
      this.password = pass
    },
    setUpdateData(user) {
      this.currentForm = this.state.UPDATE_USER
      this.tempUser = user
      if (!user.firstName) {
        this.tempUser ? this.tempUser.firstName = '' : null
      }
      if (!user.lastName) {
        this.tempUser ? this.tempUser.lastName = '' : null
      }
    },
    closeDialog() {
      this.dialog = false;
      this.currentForm = "select_screen";
    },
    loginWithNumber(params) {
      this.changeView(this.state.LOGIN)
      this.prefilledMobile = params.mobile
    },
    loggedInUser(value) {
      if (value.onlineSluttKundeId && this.returnUrl) {
        this.showRedirectScreen = true;
        if (localStorage.getItem('returnUrl')) {
          localStorage.removeItem('returnUrl')
        }
        window.open(this.returnUrl, "_self");
      }
      this.currentUser = value;
    },
    startEmailVerification(value) {
      const hasOauthEnum = ![undefined, null].includes(value.data.oauthSourceEnum) && typeof value.data.oauthSourceEnum === 'number' && value.data.oauthSourceEnum >= 0
      // TODO: update new logic using redirect with query params only, without window opener, apply /api/v2/vipps/get-token-and-login call here
      if ((value.data?.nextStep === this.state.EMAILCODE || value.data?.nextStep === this.state.SMSCODE ) && !hasOauthEnum) {
        this.email = value.data.fixitNoUser.email;
        this.clientIdentity = value.data.clientIdentity;
        this.username = value.data.fixitNoUser.mobileNumber;
        this.vippsEmail = value.data.vippsEmail;
        this.currentForm = value.data.nextStep;
        if (!this.dialog) {
          this.dialog = true
        }
      } else if ((value.data.nextStep === 'update-userdata' || value.data.nextStep === 'insert-userdata') && !hasOauthEnum) {
        this.tempUser = value.data.fixitNoUser
        this.email = value.data.fixitNoUser.email;
        this.clientIdentity = value.data.clientIdentity;
        this.username = value.data.fixitNoUser.mobileNumber;
        this.vippsEmail = value.data.vippsEmail;
        this.currentForm = value.data.nextStep;
        this.initialCreateStep = value.data.nextStep;
        if (!value.data.fixitNoUser.firstName) {
          this.tempUser ? this.tempUser.firstName = '' : null
        }
        if (!value.data.fixitNoUser.lastName) {
          this.tempUser ? this.tempUser.lastName = '' : null
        }
        if (!this.dialog) {
          this.dialog = true
        }
      } else if (hasOauthEnum && value.data?.oauthUserId?.length > 0) {
        this.oauthData = value.data
        this.tempUser = value.data.fixitNoUser
        this.email = value.data.fixitNoUser.email;
        this.clientIdentity = value.data.clientIdentity;
        this.username = value.data.fixitNoUser.mobileNumber;
        this.vippsEmail = value.data.vippsEmail;
        this.currentForm = value.data.nextStep;
        this.initialCreateStep = value.data.nextStep;
        this.oauthUserId = value.data.oauthUserId;

        if (!value.data.fixitNoUser.firstName) {
          this.tempUser ? this.tempUser.firstName = '' : null
        }
        if (!value.data.fixitNoUser.lastName) {
          this.tempUser ? this.tempUser.lastName = '' : null
        }
        if (!this.dialog) {
          this.dialog = true
        }
        this.currentForm = 'oauth-flow';
        this.initialCreateStep = value.data.nextStep;
      } else if (
        (value.data?.nextStep == null ||
          value.data?.nextStep === this.state.WELCOME) &&
        value.data.fixitNoUser != null
      ) {
        if (value.data.jwtToken)
          this.loggedInUser(value.data.fixitNoUser);
      }
    },
    changeView(view) {
      !["terms_of_use"].includes(this.currentForm)
        ? (this.previousForm = this.currentForm)
        : null;
      this.currentForm = view;
    },
    setCode(value) {
      this.code = value;
    },
    async verifyMissingInfo(value) {
      var body = {
        username: this.tempUser.mobileNumber,
        isTpn: this.isTpn.toString(),
        password: this.password,
        tpnChainId: this.tpnChainId.toString(),
        tpnSiteId: this.tpnSiteId.toString(),
        step: this.currentForm,
        firstName: value.firstName,
        lastName: value.lastName,
        oauthSourceEnum: this.oauthSourceEnum,
        oauthUserId: this.oauthUserId
      };
      if (!service) {
        service = await AppSvc(this.useAxios ? this.$axios : null);
      }
      service.VerifyLoginStep(this.apiUrl, body, this.isVippsLogin, this.isGoogleLogin).then((response) => {
        this.error = "";
        if (response.data.responseCode === 200) {
          var result = response.data;
          this.clientIdentity = result.clientIdentity;
          this.previousForm = this.currentForm;
          this.currentForm = result.nextStep;
          if (result.nextStep === "welcome-screen") {
            this.currentUser = result.fixitNoUser;
          }
        } else {
          this.error = response.data.responseMessage;
        }
      });
    },
    resendCode() {
      var body = {
        username: this.username,
        isTpn: this.isTpn.toString(),
        tpnChainId: this.tpnChainId.toString(),
        tpnSiteId: this.tpnSiteId.toString(),
        step: this.previousForm,
        email: this.email,
        resendCode: 'true',
        oauthSourceEnum: this.oauthSourceEnum,
        oauthUserId: this.oauthUserId
      };

      service.VerifyLoginStep(this.apiUrl, body, this.isVippsLogin, this.isGoogleLogin).then((response) => {
        if (response.data.responseCode === 200) {
          var result = response.data;
          this.clientIdentity = result.clientIdentity;
        }
      });
    },
    closeError() {
      this.$router.replace({ query: null });

      this.paymentError = false;
    },
  },
  async created() {
    service = await AppSvc(this.useAxios ? this.$axios : null);

    if (this.$route.query.action && this.$route.query.action == "register") {
      var verifyUser = await service.CheckCustomerForGlobalProfile(
        this.apiUrl,
        this.$route.query
      );
      switch (verifyUser) {
        case 0:
          this.changeView(this.state.REGISTRATION);
          break;
        case 1:
          // we just continue with the login
          break;
        case 2:
          // show message
          this.paymentError = true;
          break;
      }
    }

  },
  async mounted() {
    this.isMounted = true;
    if (this.$route.query && this.$route.query.returnUrl) {
      this.returnUrl = this.$route.query.returnUrl;
      if (this.$route.hash != "") {
        this.returnUrl += this.$route.hash;
      }
      localStorage.setItem('returnUrl', this.returnUrl)
    }
    if (this.$route.query && this.$route.query.fullPath) {
      localStorage.setItem('fullPath', this.$route.query.fullPath)
    }
    // login user if coming from vipps oauth
    if (this.$route.query.origin != null) localStorage.setItem('origin', this.$route.query.origin)
    if (this.$route.query.oauthTarget != null) {
      localStorage.setItem('oauthTarget', this.$route.query.oauthTarget)
      this.isVippsLogin = true
      let service = await AppSvc(this.useAxios ? this.$axios : null);
      let oauthResponse = await service.ThirdPartyOauthLogin(this.apiUrl, this.$route.query.siteId, this.$route.query.customerId, this.$route.query.code, this.$route.query.oauthTarget, this.$route.query.appleUser)
      this.startEmailVerification(oauthResponse)
      if (this.$route.query.siteId != null) {
        this.$router.replace({ 'query': {siteId: this.$route.query.siteId } });
      } else {
        this.$router.replace({ 'query': null });
      }
    }
  },
  created() {
    if (localStorage.getItem('returnUrl') && !this.returnUrl) {
      this.returnUrl = localStorage.getItem('returnUrl');
    }
  },
  watch: {
    currentForm(value) {
      // Reset forms when dialog's current form is set to 'login' again.
      if ([this.state.LOGIN].includes(value)) {
        // this.reset();
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/login.scss";
</style>
